import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SupervisorService } from 'src/app/providers/supervisor/supervisor.service';
import { map } from 'rxjs/operators';

interface DialogData {
  email: string;
}

@Component({
  selector: 'app-user-modal',
  templateUrl: './supervisor-modal.component.html',
  styleUrls: ['./supervisor-modal.component.scss']
})
export class SupervisorModalComponent implements OnInit {
  supervisorForm: FormGroup;
  router: any;

  local_data: any;
  id: number;
  firstname: string;
  lastname: string;
  teacherid: number;
  phone: number;
  email: string;

  constructor(public fb: FormBuilder,
    public dialogRef: MatDialogRef<SupervisorModalComponent>,
    private supervisorService: SupervisorService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.supervisorForm = new FormGroup({
      firstname: new FormControl(),
      lastname: new FormControl(),
      teacherid: new FormControl(),
      phone: new FormControl(),
      email: new FormControl()
    });

    this.supervisorForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      teacherid: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]]
    })
  }

  editForm() {
    this.supervisorForm = new FormGroup({
      firstname: new FormControl(),
      lastname: new FormControl(),
      teacherid: new FormControl(),
      phone: new FormControl(),
      email: new FormControl()
    });

    this.supervisorForm = this.fb.group({
      firstname: [this.data.firstname, [Validators.required]],
      lastname: [this.data.lastname, [Validators.required]],
      teacherid: [this.data.teacherid, [Validators.required]],
      phone: [this.data.phone, [Validators.required]],
      email: [this.data.email, [Validators.required]]
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addSupervisor() {
    if (!this.id) {
      console.log(this.supervisorForm.value);
      this.supervisorService.addSupervisor(this.supervisorForm.value)
        .pipe(map(
          data => {  return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {
      console.log(this.supervisorForm.value);
      this.supervisorService.editSupervisor(this.id, this.supervisorForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }
  }

  ngOnInit(): void {
  }

}
